import { render, staticRenderFns } from "./RegistCompleted.vue?vue&type=template&id=f554e080"
import script from "./RegistCompleted.vue?vue&type=script&lang=js"
export * from "./RegistCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports